export default __webpack_public_path__ + "static/media/single_digit.d6964f58.png";